// extracted by mini-css-extract-plugin
module.exports = {"button":"_80ad21f8ef--button--wvpRY"};